import { createFileRoute } from '@tanstack/react-router';

import { findSettingsNavItemByPath } from '@apps/web/components/settings/settings_nav_items';
import { SettingsLayout } from '@apps/web/features/settings';
import { modeStore } from '@apps/web/lib/mode_store';

export const Route = createFileRoute('/_app/settings')({
    // Preserve the sandbox/live mode context the old (main) layout provided.
    beforeLoad: modeStore.activate,
    onLeave: modeStore.deactivate,
    // Child settings pages set no title of their own, so name the tab after
    // the sidebar item for the current page.
    head: ({ matches }) => {
        const pathname = matches[matches.length - 1]?.pathname ?? '';
        const label = findSettingsNavItemByPath(pathname)?.label ?? 'Settings';
        return { meta: [{ title: `${label} | Phoebe` }] };
    },
    component: SettingsLayout,
});
